export default "__VITE_ASSET___PeA7PPQ__"